import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function FolderIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m8.6 4.944-.67-1.363c-.192-.392-.288-.589-.432-.732a1.2 1.2 0 0 0-.448-.282C6.86 2.5 6.644 2.5 6.213 2.5H3.92c-.672 0-1.008 0-1.265.133-.226.117-.41.304-.524.534C2 3.43 2 3.771 2 4.456v.488m0 0h9.12c1.008 0 1.512 0 1.897.2.339.176.614.457.787.801.196.393.196.906.196 1.933v2.689c0 1.026 0 1.54-.196 1.932a1.8 1.8 0 0 1-.787.801c-.385.2-.889.2-1.897.2H4.88c-1.008 0-1.512 0-1.897-.2a1.8 1.8 0 0 1-.787-.801C2 12.107 2 11.593 2 10.567z" /></svg>
  );
}

export default FolderIcon;
